import BaseEnum from './base_enum';

export default {
  measures: [
    new BaseEnum('unit', 'Unidade'),
    new BaseEnum('monetary', 'Monetário')
  ]
};
